export interface TaxPayerUser {
  id?: number;
  userId?: number;
  companyId?: number;
  isSuperUser?: boolean;
  role?: string;
  permissions?: string[];
  email?: string;
  firstName?: string;
  lastName?: string;
  password1?: string;
  password2?: string;
  allEstablishments?: boolean;
  establishmentIds?: number[];
  createdAt?: string;
  updatedAt?: string;
}

export const newTaxPayerUser = (): TaxPayerUser => {
  return {
    id: undefined,
    userId: undefined,
    companyId: undefined,
    isSuperUser: false,
    permissions: [],
    email: "",
    firstName: "",
    lastName: "",
    allEstablishments: true,
    establishmentIds: [],
  };
};

export default TaxPayerUser;
